import { useCallback, useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import type { MoTravelPeriodParams } from '../types/moTravel.types';
import { getPeriodRange, isDayInPeriod } from '../utils/moTravelPeriod';

const moTravelDetailRouteApi = getRouteApi('/_auth/geo-location/mo-travel-history/$userId');

export function useMoTravelDetailSearch() {
  const search = moTravelDetailRouteApi.useSearch();
  const navigate = moTravelDetailRouteApi.useNavigate();

  const period = useMemo<MoTravelPeriodParams>(
    () => ({ date: search.date, mapOn: search.mapOn }),
    [search.date, search.mapOn],
  );
  const periodRange = useMemo(
    () => getPeriodRange(search.date, search.mapOn),
    [search.date, search.mapOn],
  );
  const selectedDay = search.day && isDayInPeriod(periodRange, search.day) ? search.day : null;

  const handlePeriodChange = useCallback(
    (periodChange: Partial<MoTravelPeriodParams>) => {
      void navigate({
        search: (previous) => ({ ...previous, ...periodChange, day: undefined }),
        replace: true,
      });
    },
    [navigate],
  );

  const handleDaySelect = useCallback(
    (day: string | null) => {
      void navigate({
        search: (previous) => ({ ...previous, day: day ?? undefined }),
        replace: true,
      });
    },
    [navigate],
  );

  const handleDayInPeriodPick = useCallback(
    (day: string) => {
      void navigate({ search: (previous) => ({ ...previous, date: day, day }), replace: true });
    },
    [navigate],
  );

  return {
    period,
    selectedDay,
    handlePeriodChange,
    handleDaySelect,
    handleDayInPeriodPick,
  };
}
